import { Box, Button, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";

import SimpleModal from "@/components/SimpleModal.tsx";
import { forceReload } from "@/models/BootstrapUtils.ts";

export default function ForceReloadApplicationButton({
  position,
  type,
}: {
  position: "fixed" | "relative";
  type: "button" | "modal";
}) {
  const theme = useTheme();
  const [showButton, setShowButton] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [buttonSx, setButtonSx] = useState({
    position,
    right: position === "fixed" ? "1rem" : "",
    bottom: position === "fixed" ? "1rem" : "",
  });

  const reloadApplication = () => {
    setDisabled(true);
    forceReload()
      .then(() => {
        setDisabled(false);
        window.location.reload();
      })
      .catch((e) => {
        setDisabled(false);
        console.log({ e });
        window.location.reload();
      });
  };

  useEffect(() => {
    const timeoutId = setTimeout(
      () => {
        setShowButton(true);
      },
      position === "relative" ? 10 : 5000,
    );
    return () => clearTimeout(timeoutId);
  }, [position]);

  if (type === "modal") {
    return (
      <SimpleModal disableClose={false} open={true} title="Invalid App State">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100px",
            justifyContent: "center",
          }}
        >
          <Button
            disabled={disabled}
            onClick={reloadApplication}
            variant="contained"
            sx={{ p: "30px" }}
            className="basic-button"
          >
            Please Click To Reload
          </Button>
        </Box>
      </SimpleModal>
    );
  }

  return (
    <Box
      sx={{
        display: showButton ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        ...buttonSx,
      }}
    >
      <button
        disabled={disabled}
        style={{ padding: "0.25rem  0.5rem" }}
        onClick={reloadApplication}
        className="basic-button grays"
      >
        Click To Clear Cache & Reload
      </button>
    </Box>
  );
}
